import { useMemo } from "react";
import { HomeTableAccess } from "../../store";
import { SellingPlanGroupStoreAccess } from "@vendor-app/app/_state/zustand/SellingPlansStore";
import { useActiveOrganizationSelector } from "@vendor-app/app/_state/reducers/organizations";
import { parseHomeTableData } from "./parseHomeTableData";
import { HomePageTableTab } from "@vendor-app/app/AdminRoute/AdminHomeRoute/utils";

export const useParsedTableData = (selectedTab: HomePageTableTab) => {
  const subscriptions = HomeTableAccess.useData();
  const sellingPlanGroups = SellingPlanGroupStoreAccess.useGroups();
  const activeOrg = useActiveOrganizationSelector();

  return useMemo(() => {
    return parseHomeTableData(subscriptions, sellingPlanGroups, activeOrg, selectedTab);
  }, [subscriptions, sellingPlanGroups, activeOrg]);
};
